export function createTransitionOverlay(
  brandRgb: string,
  durationMs = 120,
): HTMLDivElement {
  const overlay = document.createElement('div');
  overlay.id = 'pageTransitionOverlay';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.position = 'fixed';
  overlay.style.inset = '0';
  overlay.style.zIndex = '99999';
  overlay.style.opacity = '0';
  overlay.style.pointerEvents = 'none';
  overlay.style.transition = `opacity ${durationMs}ms ease`;
  overlay.style.background = `radial-gradient(ellipse 70% 80% at top left, rgba(${brandRgb}, 0.22), transparent 50%), radial-gradient(ellipse 70% 80% at bottom right, rgba(${brandRgb}, 0.18), transparent 50%), linear-gradient(135deg, #1a1a1a 0%, #222222 100%)`;
  document.body.appendChild(overlay);
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  overlay.offsetHeight;
  return overlay;
}

export function fadeOutAndRemoveOverlay(
  overlay: HTMLElement,
  durationMs = 120,
) {
  overlay.style.transition = `opacity ${durationMs}ms ease`;
  overlay.style.opacity = '0';
  setTimeout(() => overlay.remove(), durationMs);
}

